//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Skeleton } from "ant-design-vue";
import "ant-design-vue/es/skeleton/style/index.css"
import Hexagon from "@/components/objects/public/shared-blocks/Hexagon.vue";
import IconView from "@/components/objects/IconView.vue";
import typo from "ru-typo";
import debounce from "lodash/debounce.js"
import { v4 as uuidv4 } from 'uuid';
import { BUILD_STORAGE_IMAGE_PATH } from "@/constants/ui.js";

export default {
  name: "Blue",

  components: { Hexagon, IconView, 'a-skeleton': Skeleton, },
  inject: {
    specialProject: {
      default: false
    }
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    useStorage: {
      type: Boolean
    },
    label: {
      type: String,
      default: ''
    },
    objectLabel: {
      type: String,
      default: ''
    },
    design: {
      type: String,
    },
    template: {
      type: Object,
    },
    listInfo: {
      type: Object,
    },
    user: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      isSmall: undefined,
      domId: ''
    }
  },
  computed: {
    backgroundItems() {
      if (this.isSmall === undefined) return []
      let insertIndex = 0

      const sourceItems = this.items.filter(el => !el.loader)

      const items = sourceItems.map((el, index) => {
        const item = JSON.parse(JSON.stringify(el))
        item.id = `${el.id}_${index}`
        item.target_object.text = typo(el.target_object.text, { hyphens: true })
        item.text = typo(el.text, { hyphens: true })
        item.staticImageUrl = ''

        if (item.target_object.has_image) {
          if (this.useStorage) {
            item.staticImageUrl = BUILD_STORAGE_IMAGE_PATH(item.image)
          } else {
            item.staticImageUrl = `/public/object_images_files/first_image/${item.target_object.id}/?preview=1`
          }
        }
        return item
      })

      if (this.isSmall) {
        if (items.length > 3 && items.length % 3 !== 1) {
          insertIndex = 2
        }
      } else {
        if ([4, 5].includes(items.length)) {
          insertIndex = 1
        } else if (items.length > 5) {
          insertIndex = 3
        }
      }

      items.splice(insertIndex, 0, {
        id: uuidv4(),
        humanReadableValue: this.label,
        value: {
          type: 'label'
        }
      })

      if (this.items.some(i => i.loader)) {
        items.push({
          id: 'load-next',
          loader: true,
          value: {},
        })
      }

      return items
    },
    wrapperClassList() {
      const itemsLength = this.backgroundItems.length

      return {
        'two': itemsLength === 2,
        'three': itemsLength === 3,
        'four': itemsLength === 4,
        'six': itemsLength === 6,
        'eight': itemsLength >= 8 && itemsLength % 5 === 3,
        'four-six': 3 < itemsLength && itemsLength < 7,
        'many': itemsLength > 6,
        'small-center': itemsLength === 3 || itemsLength % 3 === 1
      }
    },
  },
  mounted() {
    this.checkIsSmall()
    this.domId = `links-${this.listInfo.id}`
    window.addEventListener('resize', this.resizeHandler, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler, { passive: true })
  },
  methods: {
    computeValFontSize(descr = "") {
      const length = descr.length;

      if (length <= 25) return 16
      else if (length < 35) return 14
      return 13
    },
    checkIsSmall() {
      this.isSmall = this.$refs['objects-links'].clientWidth <= 500
    },
    resizeHandler: debounce(function () {
      this.checkIsSmall()
    }, 150)
  }
}
